// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TwoColumnsText {
    flex-direction: column;
}

.TwoColumnsText-content {
    flex-direction: row;
    @media screen and (max-width: 992px) and (min-width: 576px) {
        gap: 16px;
        
    }
}

.TwoColumnsText-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    padding-top: 100px;
    padding-bottom: 60px;
}

.TwoColumnsText-box {
    display: flex;
    border-radius: 32px;
    aspect-ratio: 1;
    padding: 40px;
}

.TwoColumnsText-text {
    flex-shrink: 0;
    flex-direction: column;
    justify-content: space-between;
}

.TwoColumnsText-text h6 {
    font-weight: 400;
    margin-bottom: 0;
}


.TwoColumnsText .b2-body-400 h1 {
    font-size: 52px;
}

@media screen and (max-width: 1024px) {
    .TwoColumnsText-title {
        padding-bottom: 0px;
    }

    .TwoColumnsText-box {
        border-radius: 16px;
    }

    .TwoColumnsText-text {
        margin-top: 32px;
    }
}

.TwoColumnsText .b2-body-400 h1,
.TwoColumnsText .b2-body-400 h2 {
  margin-top: 0;
}

.TwoColumnsText .b2-body-400 h1,
.TwoColumnsText .b2-body-400 h2,
.TwoColumnsText .b2-body-400 h3,
.TwoColumnsText .b2-body-400 h4,
.TwoColumnsText .b2-body-400 h5,
.TwoColumnsText .b2-body-400 h6 {
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/css/TwoColumnsText.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB;QACI,SAAS;;IAEb;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;;EAME,oBAAoB;AACtB","sourcesContent":[".TwoColumnsText {\n    flex-direction: column;\n}\n\n.TwoColumnsText-content {\n    flex-direction: row;\n    @media screen and (max-width: 992px) and (min-width: 576px) {\n        gap: 16px;\n        \n    }\n}\n\n.TwoColumnsText-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    padding-top: 100px;\n    padding-bottom: 60px;\n}\n\n.TwoColumnsText-box {\n    display: flex;\n    border-radius: 32px;\n    aspect-ratio: 1;\n    padding: 40px;\n}\n\n.TwoColumnsText-text {\n    flex-shrink: 0;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.TwoColumnsText-text h6 {\n    font-weight: 400;\n    margin-bottom: 0;\n}\n\n\n.TwoColumnsText .b2-body-400 h1 {\n    font-size: 52px;\n}\n\n@media screen and (max-width: 1024px) {\n    .TwoColumnsText-title {\n        padding-bottom: 0px;\n    }\n\n    .TwoColumnsText-box {\n        border-radius: 16px;\n    }\n\n    .TwoColumnsText-text {\n        margin-top: 32px;\n    }\n}\n\n.TwoColumnsText .b2-body-400 h1,\n.TwoColumnsText .b2-body-400 h2 {\n  margin-top: 0;\n}\n\n.TwoColumnsText .b2-body-400 h1,\n.TwoColumnsText .b2-body-400 h2,\n.TwoColumnsText .b2-body-400 h3,\n.TwoColumnsText .b2-body-400 h4,\n.TwoColumnsText .b2-body-400 h5,\n.TwoColumnsText .b2-body-400 h6 {\n  margin: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
